module.exports = __webpack_public_path__ + "img/phone.4d7fb8d8.svg";